function hasPermission(permissionList, routePath) {
  if (routePath === '*' || routePath === '/') return true
  return !!permissionList.includes(routePath)
}

export function filterAsyncRouter(routerMap, authRoute) {
  if (authRoute === '*') {
    return routerMap
  }
  const map = routerMap.filter((route) => {
    if (hasPermission(authRoute, route.path)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, authRoute)
      }
      return true
    }
    return false
  })
  return map
}
